<template>
  <v-row justify="center">
    <v-dialog scrollable max-width="400px" v-model="showDialog">
      <template v-slot:activator="{ on }">
        <v-btn color="info" small v-on="on">Enviar por email</v-btn>
      </template>

      <v-card>
        <v-card-title>Ingrese la direccion de correo</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 100px;">
          <v-form v-model="validEmail" ref="form">
            <v-text-field v-model="email" :rules="[rules.required, rules.email]" label="E-mail"></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <!-- <v-btn color="blue darken-1" text @click="dialog = false">Cerrar</v-btn> -->
          <v-btn color="blue darken-1" text @click="close">Cerrar</v-btn>

          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            :disabled="enviarEmailDisabled ? true : !validEmail "
            text
            @click="enviarEmail()"
          >{{btnEnviar}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="3000">
      Correo enviado!
      <v-btn color="blue" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  props: ["id"],
  data() {
    return {
      showDialog: false,
      enviarEmailDisabled: false,
      email: "",
      snackbar: false,
      rules: {
        required: value => !!value || "Requerido.",
        counter: value => value.length <= 20 || "Max 20 caracteres",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "email invalido.";
        }
      },
      validEmail: false,
      btnEnviar: "Enviar"
    };
  },
  methods: {
    close() {
      this.$refs.form.reset();
      this.showDialog = false;
    },
    enviarEmail() {
      this.btnEnviar = "Enviado . . .";
      this.enviarEmailDisabled = true;

      console.log(
        "enviar a " + "/email/liquidacion?id=" + this.id + "&to=" + this.email
      );

      axios
        .get("/email/liquidacion?id=" + this.id + "&to=" + this.email)
        .then(response => {
          console.log(response);
          if (response.data === "enviado") {
            this.showDialog = false;
            this.btnEnviar = "Enviar";
            this.enviarEmailDisabled = false;
            this.snackbar = true;
          } else {
            this.btnEnviar = "error";
          }
        })
        .catch(err => {
          console.log(err);
          this.btnEnviar = "error";
        });
    }
  }
});
</script>